import styled from '@emotion/styled';
import { colors } from 'inpock-ui-react/dist/src/color';

export const BottomSheet = styled.section`
  display: flex;
  flex-direction: column;
  gap: 15px;
  height: 100%;
  padding: 30px 0px;
`;

export const BtnSignup = styled.div`
  text-align: center;
  padding: 8px;
  border-radius: 8px;
  background-color: ${colors.gray100};

  .cursor-pointer {
    cursor: pointer;
  }
`;
